import { Theme, makeStyles, createStyles } from '@material-ui/core/styles';
import { CommonButtonTypes } from 'Common/Types/Types';

export const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		root: {
			display: 'flex',
			justifyContent: 'center',
			flexDirection: 'column',
			margin: '10rem auto',
			maxWidth: 345,
		},
		card: {
			maxWidth: 345,
		},
		media: {
			height: 140,
		},
		description: {
			fontFamily: 'Poppins',
			fontSize: '14px',
			width: '90%',
			margin: '0 auto',
		},
		loading: {
			display: 'flex',
			justifyContent: 'center',
			flexDirection: 'column',
			alignItems: 'center',
			marginTop: '3rem',
		},
		pagination: { margin: '2rem auto', display: 'flex', justifyContent: 'center' },
		listItems: {
			listStyleType: 'none',
			margin: 0,
			padding: 0,
			width: '100%',
			justifyContent: 'space-around',
			[theme.breakpoints.down('xs')]: {
				// fontSize: '16px',
			},
		},
		topImage: {
			display:'flex',
			width: '70%',
			height: '473px',
			borderRadius: '10px',
			objectFit: 'contain',
			margin:'0 auto',
			[theme.breakpoints.down('xs')]: {
				width: '100%',
			},
		},
	}),
);
